<div class="pms-settings" [formGroup]="form">
  <div class="section-header">
    <h6 class="section-title">{{ 'PMSSettings.Meals' | translate }}</h6>
    <p class="section-desc">{{ 'PMSSettings.MealsDesc' | translate }}</p>
  </div>

  <div class="meal-cards">
    <div
      class="meal-card"
      *ngFor="let meal of meals"
      [formGroupName]="meal.type"
      [class.meal-card--disabled]="!isEnabled(meal.type)"
    >
      <!-- Header: icon + label + enabled toggle -->
      <div class="meal-card__header">
        <div class="meal-card__title">
          <mat-icon class="meal-icon">{{ meal.icon }}</mat-icon>
          <span>{{ meal.labelKey | translate }}</span>
        </div>
        <mat-slide-toggle formControlName="enabled"></mat-slide-toggle>
      </div>

      <!-- Body — only visible when enabled -->
      <div class="meal-card__body" *ngIf="isEnabled(meal.type)">
        <!-- Duration + Time -->
        <div class="field-row">
          <div class="form-group field-group">
            <label class="field-label">{{ 'PMSSettings.Duration' | translate }}</label>
            <div class="input-suffix-wrap">
              <input class="form-control" type="number" formControlName="duration" min="1" max="480" />
              <span class="input-suffix">{{ 'PMSSettings.Min' | translate }}</span>
            </div>
          </div>

          <div class="form-group field-group">
            <label class="field-label">{{ 'PMSSettings.Time' | translate }}</label>
            <ng-select
              [items]="timeOptions"
              bindLabel="label"
              bindValue="value"
              formControlName="time"
              [searchable]="true"
              [clearable]="false"
              appendTo="body"
            ></ng-select>
          </div>
        </div>

        <!-- Automatic placement toggle -->
        <div class="form-group field-row field-row--spread">
          <span class="field-label">{{ 'PMSSettings.AutoPlacement' | translate }}</span>
          <mat-slide-toggle formControlName="automaticPlacement"></mat-slide-toggle>
        </div>

        <!-- Placement mode -->
        <div class="form-group" *ngIf="isAutomaticPlacementOn(meal.type)">
          <label class="field-label">{{ 'PMSSettings.PlacementMode' | translate }}</label>
          <div class="btn-toggle-group">
            <button
              type="button"
              class="btn-toggle"
              [class.btn-toggle--active]="!isUseTemplate(meal.type)"
              (click)="setPlacementMode(meal.type, 'import_only')"
            >
              {{ 'PMSSettings.ImportOnly' | translate }}
            </button>
            <button
              type="button"
              class="btn-toggle"
              [class.btn-toggle--active]="isUseTemplate(meal.type)"
              (click)="setPlacementMode(meal.type, 'use_template')"
            >
              {{ 'PMSSettings.UseTemplate' | translate }}
            </button>
          </div>
        </div>

        <!-- Template dropdown -->
        <div class="form-group shift-content" *ngIf="isUseTemplate(meal.type)">
          <label class="field-label">{{ 'PMSSettings.Template' | translate }}</label>
          <ng-select
            [items]="shifts"
            bindLabel="name"
            bindValue="id"
            formControlName="templateId"
            [searchable]="true"
            [clearable]="true"
            [placeholder]="'PMSSettings.SelectTemplate' | translate"
            appendTo="body"
          ></ng-select>
        </div>

        <!-- Breakfast: served on departure day -->
        <div class="form-group field-row field-row--spread" *ngIf="meal.type === 'breakfast'">
          <span class="field-label">{{ 'PMSSettings.ServedOnDeparture' | translate }}</span>
          <div class="toggle-with-default">
            <span class="default-badge">{{ 'PMSSettings.Default' | translate }}</span>
            <mat-slide-toggle formControlName="servedOnDeparture"></mat-slide-toggle>
          </div>
        </div>

        <!-- Dinner: served on arrival day -->
        <div class="form-group field-row field-row--spread" *ngIf="meal.type === 'dinner'">
          <span class="field-label">{{ 'PMSSettings.ServedOnArrival' | translate }}</span>
          <div class="toggle-with-default">
            <span class="default-badge">{{ 'PMSSettings.Default' | translate }}</span>
            <mat-slide-toggle formControlName="servedOnArrival"></mat-slide-toggle>
          </div>
        </div>

        <!-- Lunch: arrival/departure day chips -->
        <div class="form-group" *ngIf="meal.type === 'lunch'">
          <label class="field-label">{{ 'PMSSettings.ServingDays' | translate }}</label>
          <div class="chip-group">
            <button
              type="button"
              class="chip"
              [class.chip--active]="isChipActive(meal.type, 'arrivalDay')"
              (click)="toggleChip(meal.type, 'arrivalDay')"
            >
              {{ 'PMSSettings.ArrivalDay' | translate }}
            </button>
            <button
              type="button"
              class="chip"
              [class.chip--active]="isChipActive(meal.type, 'departureDay')"
              (click)="toggleChip(meal.type, 'departureDay')"
            >
              {{ 'PMSSettings.DepartureDay' | translate }}
            </button>
          </div>
          <p class="field-hint">{{ 'PMSSettings.LunchHint' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Manual placement -->
  <div class="section-header section-header--spaced">
    <h6 class="section-title">{{ 'PMSSettings.AutoPlacement' | translate }}</h6>
    <p class="section-desc">{{ 'PMSSettings.AutoPlacementDesc' | translate }}</p>
  </div>

  <div class="global-card" [formGroupName]="'__global'">
    <div class="field-row">
      <!-- <div class="form-group field-group">
        <label class="field-label">{{ 'PMSSettings.DateFilter' | translate }}</label>
        <ng-select
          [items]="dateFilterOptions"
          bindLabel="label"
          bindValue="value"
          formControlName="dateFilter"
          [searchable]="false"
          [clearable]="false"
          appendTo="body"
        >
          <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
        </ng-select>
      </div> -->

      <div class="form-group field-group">
        <label class="field-label">{{ 'PMSSettings.LeadTime' | translate }}</label>
        <div class="input-suffix-wrap">
          <input class="form-control" type="number" formControlName="leadTime" min="1" max="365" />
          <span class="input-suffix">{{ 'PMSSettings.Days' | translate }}</span>
        </div>
      </div>

      <!-- NEW: Same table for all meals -->
      <div class="form-group field-group field-group--toggle">
        <label class="field-label">{{ 'PMSSettings.SameTableAllMeals' | translate }}</label>
        <div class="toggle-wrap">
          <mat-slide-toggle formControlName="sameTableAllMeals"></mat-slide-toggle>
        </div>
      </div>
      <!-- <p class="field-hint">{{ 'PMSSettings.SameTableAllMealsDesc' | translate }}</p> -->
    </div>
  </div>

  <!-- Save -->
  <div class="form-actions">
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving || form.invalid">
      <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ (saving ? 'PMSSettings.Saving' : 'PMSSettings.Save') | translate }}
    </button>
  </div>
</div>
